import { render, staticRenderFns } from "./ModalContentAddVirtualMemberManual.vue?vue&type=template&id=08b2ba3d&scoped=true&"
import script from "./ModalContentAddVirtualMemberManual.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddVirtualMemberManual.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddVirtualMemberManual.vue?vue&type=style&index=0&id=08b2ba3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2ba3d",
  null
  
)

export default component.exports